module.exports = __webpack_public_path__ + "img/img_prize1.e8731ab6.png";